import { mode } from '@chakra-ui/theme-tools'

// https://github.com/chakra-ui/chakra-ui/blob/master/packages/theme/src/components/checkbox.ts
export const Checkbox = {
  baseStyle: (props) => ({
    control: {
      _disabled: {
        bg: mode('gray.100', 'whiteAlpha.100')(props),
        borderColor: mode('gray.200', 'transparent')(props),
        _invalid: { borderColor: mode('gray.200', 'transparent')(props) },
      },
    },
    label: {
      _checked: {
        color: 'inherit',
      },
      _disabled: {
        color: 'gray.600',
        opacity: 1,
      },
    },
  }),

  sizes: {
    md: {
      control: { w: 5, h: 5, borderRadius: 'md' },
      label: { fontSize: 'sm' },
    },
  },
}
